(function () {
  let checkInterval = null;
  let maxAttempts = 20;
  let attempts = 0;

  function activateIfNeeded() {
    attempts++;
    const groups = window.OnetrustActiveGroups;

    if (!groups) {
      console.log('[portable-wallets] Waiting for OneTrust...');
      return;
    }

    const hasConsent = groups.includes('C0002') && groups.includes('C0003');

    if (hasConsent) {
      console.log('[portable-wallets] Consent granted — letting Shopify inject it.');
      clearInterval(checkInterval);
      return;
    }

    const blockedScript = document.querySelector('script[src*="portable-wallets"][type="text/plain"]');
    if (!blockedScript) {
      console.log('[portable-wallets] No blocked script found — assuming it’s already loaded.');
      clearInterval(checkInterval);
      return;
    }

    console.log('[portable-wallets] Consent NOT given, but script is blocked — injecting manually');

    const s = document.createElement('script');
    s.src = blockedScript.getAttribute('src');
    s.setAttribute('data-ot-ignore', '');
    s.type = 'module';
    s.crossOrigin = 'anonymous';
    s.onerror = function () {
      console.error('[portable-wallets] Manual injection failed');
    };

    document.head.appendChild(s);
    clearInterval(checkInterval);
  }

  document.addEventListener('DOMContentLoaded', () => {
    checkInterval = setInterval(() => {
      if (attempts >= maxAttempts) {
        console.warn('[portable-wallets] Max attempts reached. Stopping check.');
        clearInterval(checkInterval);
        return;
      }
      activateIfNeeded();
    }, 500);
  });
})();

